var React = require('react');

function EventInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 2v4m12-4v4M2 10h20M4 4h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

EventInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = EventInline;

EventInline.default = EventInline;
